// CANONICAL COPY (GH #7115). src/constants/obligations/obl-backup-test.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-backup-test',
  title: 'Test data backup and recovery',
  description:
    'Execute a backup recovery test for a sampling of enterprise assets. Document recovery time and any issues.',
  category: 'continuity',
  scfIds: ['SCF-BCM-003'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'manual',
  fulfilmentCriteria: [
    {
      type: 'manual-attestation',
      description: 'Confirm the backup recovery test was actually executed',
    },
  ],
  domainActions: [{ type: 'upload-artefact', label: 'Upload Evidence' }],
};
